import axios from "axios"
import {Message,Loading} from "element-ui"
import api from "./config"
// import store from '../store/index'

let loading ;
// import config from "../config/index"
let instance = axios.create({
    timeout: 10*60000,
    headers: {'content-type': 'application/json'}
});

// // 添加请求拦截器
instance.interceptors.request.use(function (config) {
    loading = Loading.service({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
    });
    const token = localStorage.getItem('token')
    config.headers['token'] = token
    if (token) {
        config.headers['Authorization'] = 'Bearer ' + token
    }
    return config;
}, function (error) {
    if (loading){
        loading.close();
    }
    return Promise.reject(error);
});


// 添加响应拦截器
instance.interceptors.response.use(function (response) {

    if (loading){
        loading.close();
    }
    return response
}, function (error) {
    if (loading){
        loading.close();
    }
    if (error.search('Timeout') === -1) {
        return Promise.reject(error);
    } else {
        Message.error('请求连接超时')
    }
    // return Promise.reject(error);
});

// export default instance




export const   commonCaptcha = () => {
    return api.api+'/captcha.jpg'
}

export const henanClueDownload = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api + '/henanClue/download', {params: params, responseType: "arraybuffer"})
            .then(response => {
                if (response) {
                    resolve(response)
                } else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

